<template>
  <sui-modal class="log-modal" size="large" v-model="visible" closable>
    <sui-modal-header>
      <i class="close icon" @click="close()" />
      Metrics
    </sui-modal-header>
    <sui-modal-content scrolling>
      <Metrics :entity="entity" v-if="entity" />
    </sui-modal-content>
  </sui-modal>
</template>

<script>
  import Metrics from '@/components/Metrics'

  export default {
    name: 'ModalMetrics',
    components: {
      Metrics,
    },
    data() {
      return {
        visible: false,
        entity: null,
      }
    },
    watch: {
      visible(newValue) {
        if (!newValue) {
          this.entity = null
        }
      }
    },
    methods: {
      open(entity) {
        this.visible = true
        this.entity = entity
      },
      close() {
        this.visible = false
      },
    },
    created() {
      this.$modals.metrics = this
    },
  }
</script>

<style scoped>
  .close { float: right; padding: .15em; opacity: .8; }
  .close:hover { opacity: 1; cursor: pointer; }
</style>
